<template>
  <span>
    <p v-if="!isError" :style="customStyle" :class="className">
      <template v-if="isMultiColor">
        <BaseIcon
          v-if="multiColorProps.enableIcon"
          :name="multiColorProps.name"
          height="1rem"
          width="1rem"
        />
        <!-- TODO: Need to remove v-html -->
        <span v-html="formColoredLable(info, multiColorPlaceholderList)"></span>
      </template>
      <template v-else>
        {{ info }}
      </template>
    </p>
    <p v-if="isError" :class="errorClass" :style="customStyle">
      <BaseIcon :name="iconName" height="0.6rem" width="0.775rem" />
      <span style="margin: 0.4rem">
        {{ info }}
      </span>
    </p>
  </span>
</template>

<script>
import format from '@/utils/messageFormat';
/**
 * Info label is used to display message or error message.
 */
export default {
  props: {
    /**
     *
     *Message to be displayed
     *
     */
    info: { type: String, required: true },
    /**
     *
     *Class name of info message
     *
     */
    className: { type: String, default: 'pt-1  mb-0 info-label' },
    /**
     *
     *Custom style for info element
     *
     */
    customStyle: { type: String, default: '' },
    /**
     *
     *Boolean set true to display message as error
     *
     */
    isError: { type: Boolean, default: false },
    /**
     *
     *Class name of error message
     *
     */
    errorClass: { type: String, default: 'validation' },
    isMultiColor: { type: Boolean, default: false },
    multiColorPlaceholderList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    multiColorProps: {
      enableIcon: { type: Boolean, default: false },
      name: { type: String, default: '' },
      default: () => {
        return {
          enableIcon: false,
        };
      },
    },
    multiColorStyle: {
      type: Object,
      default: () => {
        return { color: '#ffffff' };
      },
    },
    iconName: { type: String, default: 'errorFilter' },
  },
  data() {
    return {};
  },
  methods: {
    formColoredLable(text, multiColorPlaceholderList) {
      return this.formatString(
        text,
        multiColorPlaceholderList,
        true,
        this.multiColorStyle,
      );
    },
    formatString(pattern, _object, isColorLable, colorCode) {
      return format(pattern, _object, isColorLable, colorCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-label {
  font-size: 0.875em;
}
.validation {
  font-size: 0.875em;
  color: $poor;
}
</style>
